export default "__VITE_ASSET__DkE8H02T__"